import { coingeckoActionTypes } from "../../action-types";
import { CommonActionTypes } from "../../action-types"; // Assuming this is where your PENDING/REJECTED types live

const cachedCoingeckoData = JSON.parse(localStorage.getItem("coingeckoData"));

const initialState = {
  clientProfiles: cachedCoingeckoData ? cachedCoingeckoData : null,
  marketPrices: [], // Dedicated property to safely store the live price list array
  chartTrends: {    // Dedicated property to safely hold historical coin timelines
    coinId: null,
    days: null,
    data: null,
  },
  error: null,
};

export default function coingeckoReducer(state = initialState, action) {
  switch (action.type) {
    // 1. Properly handle cryptocurrency market lists without wiping out client profiles
    case coingeckoActionTypes.GET_CRYPTO_MARKETS_DATA:
      return {
        ...state,
        marketPrices: action.payload,
        error: null,
      };

    // 2. Properly handle detailed historical data matrices
    case coingeckoActionTypes.GET_CRYPTO_CHART_DATA:
      return {
        ...state,
        chartTrends: {
          coinId: action.payload.coinId,
          days: action.payload.days,
          data: action.payload.data,
        },
        error: null,
      };

    case coingeckoActionTypes.GET_CRYPTO_GLOBAL_STATS:
      return {
        ...state,
        globalStats: action.payload,
        error: null,
      };

    // 3. Clear data on modal unmount
    case coingeckoActionTypes.CLEAR_CRYPTO_CHART_DATA:
      return {
        ...state,
        chartTrends: initialState.chartTrends,
      };

    // 4. Handle standard global error boundaries safely
    case CommonActionTypes.REJECTED:
      return {
        ...state,
        error: action.payload?.message || "An error occurred fetching crypto analytics.",
      };

    default:
      return state;
  }
}